import React, { useContext, useState, FunctionComponent } from 'react'
import { TeeColorEllipse, TeeLengthContainer } from './TeeItem.styles'
import {
  DropDownMenuItem,
  DropDownMenuSubItem,
  DropDownSubMenuContainer,
} from '@app/ui/dropdown-menu/DropDownMenu.styles'
import { FormExGenderBtn } from '../screen/FormsTab/styled'
import { FaChevronRight } from 'react-icons/fa'
import { MITee } from '@app/evaluation-core/types'
import { DropDownMenuContext } from '@app/ui/dropdown-menu/DropDownMenu'

type OwnProps = {
  currentTeeIndex: number
  tees: MITee[]
  getTeeLengthFn: any
  // Selecting a copy target lives outside the menu (see CopyTeeFlow) so the
  // confirmation modal survives the menu closing. We just report the choice up
  // and dismiss the menu.
  onSelectTee: (tee: MITee) => void
}

type Props = OwnProps

export const CopyTeeSubMenu: FunctionComponent<Props> = ({
  currentTeeIndex,
  tees,
  getTeeLengthFn,
  onSelectTee,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const { close } = useContext(DropDownMenuContext)

  return (
    <DropDownMenuItem onPress={() => setIsOpen(!isOpen)}>
      <FormExGenderBtn>
        <span>Copy all adjustments to</span>
        <div>
          <FaChevronRight size={20} />
        </div>
      </FormExGenderBtn>
      {isOpen && (
        <DropDownSubMenuContainer useShadow={true} rounded={true}>
          {tees.map((tee) => {
            const teeLength = getTeeLengthFn(tee.teeNumber)
            return (
              <DropDownMenuSubItem
                key={tee.id}
                disabled={currentTeeIndex === tee.teeIndex}
                onPress={() => {
                  onSelectTee(tee)
                  close()
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <TeeColorEllipse color={`#${tee.color || '999999'}`} />
                  Tee {tee.teeNumber}: ({tee.name})
                  <TeeLengthContainer>{teeLength}</TeeLengthContainer>
                </div>
              </DropDownMenuSubItem>
            )
          })}
        </DropDownSubMenuContainer>
      )}
    </DropDownMenuItem>
  )
}

export default CopyTeeSubMenu
